import React from 'react';
import {
  Dialog, DialogTitle, IconButton, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { STATIC_ROOT } from 'src/static';
import { Box } from '@mui/system';


// const useStyles = makeStyles((theme) => ({
//   root:{}
// }));

interface ComponentSectionProps {
  open : boolean
  onClose : ()=>void
}

const InfoDialog: React.FC<ComponentSectionProps> = ({
  onClose,
  open,
}) => {
//   const classes = useStyles();

  return (
    <Dialog 
    //   className={classes.root}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      classes={{
          paper:"dialog-paper"
      }}
    >
        <DialogTitle style={{position:"relative"}}>
        <Typography align="center" variant="h6">Fintech Ecosystem</Typography>
        <IconButton onClick={onClose} style={{left:16,position:"absolute",top:8}}>
            <CloseIcon/>
        </IconButton>
      </DialogTitle>
       <img
        src={STATIC_ROOT.INFO_GRAPHIC}
        style={{
          borderRadius:16,
          // maxHeight:"80vh",
          // width:"auto"
        }}
      />
    </Dialog>
  )
}

export default InfoDialog;
